function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M101.47 345.85C87.7486 326.902 78.1401 305.294 73.261 282.413C68.3819 259.533 68.34 235.885 73.138 212.987C77.9361 190.09 87.4681 168.448 101.122 149.451C114.777 130.454 132.251 114.522 152.426 102.676C172.6 90.83 195.028 83.3325 218.27 80.6646C241.512 77.9966 265.055 80.2171 287.389 87.1836C309.723 94.15 330.353 105.709 347.957 121.117C365.561 136.526 379.748 155.445 389.61 176.66",
  stroke: "#39473F",
  strokeWidth: 6,
  strokeMiterlimit: 10,
  strokeDasharray: "10.79 10.79"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M530 180H275V376H530V180Z",
  className: "primary-lightened-1"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M436.5 275C449.479 275 460 264.479 460 251.5C460 238.521 449.479 228 436.5 228C423.521 228 413 238.521 413 251.5C413 264.479 423.521 275 436.5 275Z",
  className: "primary"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M454.67 284.16C449.251 287.119 443.175 288.67 437 288.67C430.825 288.67 424.749 287.119 419.33 284.16C413.472 287.374 408.586 292.104 405.185 297.856C401.784 303.607 399.993 310.168 400 316.85V327H474V316.85C474.007 310.168 472.216 303.607 468.815 297.856C465.414 292.104 460.528 287.374 454.67 284.16V284.16Z",
  className: "primary"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M368.5 275C381.479 275 392 264.479 392 251.5C392 238.521 381.479 228 368.5 228C355.521 228 345 238.521 345 251.5C345 264.479 355.521 275 368.5 275Z",
  className: "primary-lightened-2"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M386.67 284.16C381.251 287.119 375.175 288.67 369 288.67C362.825 288.67 356.749 287.119 351.33 284.16C345.472 287.374 340.586 292.104 337.185 297.856C333.784 303.607 331.993 310.168 332 316.85V327H406V316.85C406.007 310.168 404.216 303.607 400.815 297.856C397.414 292.104 392.528 287.374 386.67 284.16V284.16Z",
  className: "primary-lightened-2"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M421.8 376L402.82 408.85L383.83 376H421.8Z",
  className: "primary"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M204.86 160H205.14C207.485 160 209.808 160.462 211.975 161.36C214.142 162.257 216.111 163.573 217.769 165.231C219.427 166.89 220.743 168.858 221.641 171.025C222.538 173.192 223 175.515 223 177.86V239H187V177.86C187 175.515 187.462 173.192 188.36 171.025C189.257 168.858 190.573 166.89 192.231 165.231C193.89 163.573 195.858 162.257 198.025 161.36C200.192 160.462 202.515 160 204.86 160V160Z",
  className: "extra-color-2-darkened-1"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M315.48 428L293.48 325.8L281.48 269.8C278.284 254.937 270.844 241.32 260.063 230.601C249.281 219.881 235.622 212.52 220.74 209.41C215.69 208.41 194.22 208.41 189.18 209.41C174.298 212.519 160.638 219.88 149.856 230.599C139.075 241.319 131.635 254.936 128.44 269.8L116.44 325.8L94.4301 428H315.48Z",
  className: "extra-color-2"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M293.49 325.8L281.49 269.8C279.872 262.337 277.177 255.148 273.49 248.46L94.54 427.46L94.42 428.01H315.48L293.49 325.8Z",
  className: "extra-color-2-darkened-1"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M191.28 275L196.15 327.75L198.58 354H211.33L215.54 308.36L218.63 275H191.28Z",
  fill: "white"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M211 367H198V380H211V367Z",
  fill: "white"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 600,
    height: 500,
    viewBox: "0 0 600 500",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
};

export default __webpack_public_path__ + "static/media/check_current_feedback_providers.553c017f.svg";
export { SvgComponent as ReactComponent };